(function() {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  class OfferBanner {
    constructor(element) {
      this.element = element;
      this.endDateString = this.element.dataset.end;
      
      if (!this.endDateString) return;
      
      // Let JS parse the ISO date natively
      this.endDate = new Date(this.endDateString).getTime();
      this.interval = null;
      this.isVisible = false;

      // Cache DOM structure
      this.units = ['days', 'hours', 'minutes', 'seconds'].reduce((acc, unit) => {
        const unitEl = this.element.querySelector(`[data-unit="${unit}"]`);
        if (unitEl) {
          const digits = Array.from(unitEl.querySelectorAll('.ob-digit')).map(digitEl => ({
            container: digitEl,
            topCurr: digitEl.querySelector('.ob-flip-top--curr span'),
            bottomCurr: digitEl.querySelector('.ob-flip-bottom--curr span'),
            topNext: digitEl.querySelector('.ob-flip-top--next span'),
            bottomNext: digitEl.querySelector('.ob-flip-bottom--next span'),
            currentValue: null
          }));
          acc[unit] = digits;
        }
        return acc;
      }, {});

      this.initObserver();
    }

    initObserver() {
      // Small optimization: only run timer when banner is visible
      const options = {
        root: null,
        rootMargin: '50px', // Start slightly before it comes into view
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.startTimer();
          } else {
            this.isVisible = false;
            this.stopTimer();
          }
        });
      }, options);

      this.observer.observe(this.element);
    }

    startTimer() {
      if (this.interval) return; // Already running
      
      // Immediate tick to prevent flash of wrong data
      this.tick();
      
      // Stop if already expired during immediate tick
      if (this.getTimeRemaining().total <= 0) return;

      this.interval = setInterval(() => this.tick(), SECOND);
    }

    stopTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    getTimeRemaining() {
      const now = new Date().getTime();
      const total = this.endDate - now;
      
      if (total <= 0) {
        return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      const days = Math.floor(total / DAY);
      const hours = Math.floor((total % DAY) / HOUR);
      const minutes = Math.floor((total % HOUR) / MINUTE);
      const seconds = Math.floor((total % MINUTE) / SECOND);

      return { total, days, hours, minutes, seconds };
    }

    padZero(num) {
      return num < 10 ? `0${num}` : num.toString();
    }

    tick() {
      const t = this.getTimeRemaining();

      if (t.total <= 0) {
        this.stopTimer();
        this.hideBanner();
        return;
      }

      this.updateUnit('days', this.padZero(t.days));
      this.updateUnit('hours', this.padZero(t.hours));
      this.updateUnit('minutes', this.padZero(t.minutes));
      this.updateUnit('seconds', this.padZero(t.seconds));
    }

    updateUnit(unit, stringValue) {
      const digits = this.units[unit];
      if (!digits) return;

      // Ensure we have enough digit elements (typically 2 for mm:ss)
      // stringValue could be "12" -> "1", "2"
      for (let i = 0; i < digits.length; i++) {
        // Fallback to '0' just in case
        const newValue = stringValue[i] || '0';
        this.updateDigit(digits[i], newValue);
      }
    }

    updateDigit(digitObj, newValue) {
      // Core Feature: Independent digit animation
      // We only animate if this specific digit has changed!
      if (digitObj.currentValue === newValue) return;

      if (digitObj.currentValue === null) {
        // Initial setup without animation
        digitObj.topCurr.textContent = newValue;
        digitObj.bottomCurr.textContent = newValue;
        digitObj.currentValue = newValue;
        return;
      }

      // Prepare flip animation values
      digitObj.topNext.textContent = newValue;
      digitObj.bottomNext.textContent = newValue;

      // Restart animation by triggering a reflow
      digitObj.container.classList.remove('is-flipping');
      void digitObj.container.offsetWidth; 
      digitObj.container.classList.add('is-flipping');

      // Update current values DOM after animation completes (600ms matching CSS)
      setTimeout(() => {
        digitObj.topCurr.textContent = newValue;
        digitObj.bottomCurr.textContent = newValue;
        digitObj.container.classList.remove('is-flipping');
      }, 600);

      digitObj.currentValue = newValue;
    }

    hideBanner() {
      // Use CSS hidden state instead of removing from DOM to prevent reference bugs
      this.element.classList.add('is-hidden');
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  // Initialize modularly
  const init = () => {
    document.querySelectorAll('.offer-banner:not([data-initialized="true"])').forEach(banner => {
      new OfferBanner(banner);
      banner.setAttribute('data-initialized', 'true');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
